import React, { useEffect, useState } from "react";

import { Card, Button, Row, Form } from "react-bootstrap";
import Select, { ActionMeta } from "react-select";
import MaterialTable, {
    Column,
    EditComponentProps,
} from "@material-table/core";

import * as APIModels from "../../../../models";
import { TylerDataService } from "../../../../services/DataService";
import { TylerAdminService } from "../../../../services/ClientService";
import PartyModal from "./PartyModal";
import { Attorney } from "../../../../models/swagger/generated-submission-service";

declare global {
    interface Crypto {
        randomUUID: () => string;
    }
}

console.log(crypto.randomUUID());

export default function PartyTable({
    submission,
    parties,
    onUpdateParties,
}: {
    submission: APIModels.Submission;
    parties: APIModels.Party[];
    onUpdateParties: (parties: APIModels.Party[]) => void;
}) {
    const [caseData, setCaseData] = useState(submission.caseData);
    const [partyTypes, setPartyTypes] = useState([] as APIModels.PartyType[]);
    const [attorneys, setAttorneys] = useState([] as Attorney[]);
    const [completedParties, setCompletedParties] = useState(parties);
    const [selectedParty, setSelectedParty] = useState(
        undefined as APIModels.Party | undefined
    );
    const [selectedPartyIndex, setSelectedPartyIndex] = useState(-1);
    const [loading, setLoading] = useState(false);

    const [showPartyModal, setShowPartyModal] = useState(false);

    const handlePartyOpen = () => setShowPartyModal(true);
    const handlePartyClose = () => setShowPartyModal(false);

    useEffect(() => {
        TylerAdminService.getAttorneys().then((res) => {
            if (res.successful && res.data) {
                console.log("PartyTable.tsx => Attorneys", res.data.length);
                if (!res.data || res.data!.length === 0) {
                    setAttorneys([
                        {
                            barNumber: "00000",
                            firstName: "No",
                            lastName: "Attorneys",
                            emailAddress: "",
                        },
                    ] as Attorney[]);
                } else {
                    console.log([...res.data!]);
                    setAttorneys((_prev) => {
                        return [...res.data!] as Attorney[];
                    });
                }
            }
        });
    }, []);

    useEffect(() => {
        if (
            submission.caseData?.caseTypeID !== undefined &&
            submission.caseData?.caseTypeID !== null &&
            submission.caseData?.caseTypeID !== "" &&
            submission.caseData?.caseTypeID !==
                "00000000-0000-0000-0000-000000000000"
        ) {
            console.log({ "PartyTable.tsx => Case Data": submission.caseData });
            setLoading(true);
            setCaseData(submission.caseData ?? new APIModels.CaseData());
            TylerDataService.getPartyTypes({
                caseTypeId: submission.caseData!.caseTypeID,
            }).then(
                (resp) => {
                    setPartyTypes(resp);
                    setLoading(false);
                },
                (error) => {
                    console.log(error);
                    setLoading(false);
                }
            );
        }
    }, [submission.caseData!.caseTypeID]);

    useEffect(() => setCompletedParties(parties), [parties]);

    const onSaveParty = (party: APIModels.Party) => {
        if (!party.id) {
            party.id = crypto.randomUUID();
        }

        let temp = [...completedParties];
        if (selectedPartyIndex > 0) {
            temp.splice(selectedPartyIndex, 1, party);
            setCompletedParties(temp);
        } else {
            temp = [...completedParties, party];
            setCompletedParties([...completedParties, party]);
        }

        setSelectedParty(undefined);
        setSelectedPartyIndex(-1);

        onUpdateParties(temp);

        handlePartyClose();
    };

    return (
        <>
            {" "}
            <button className="btn btn-primary" onClick={handlePartyOpen}>
                Add Party
            </button>
            <PartyModal
                show={showPartyModal}
                partyTypes={partyTypes}
                attorneys={attorneys}
                onSaveParty={onSaveParty}
                party={
                    selectedParty ?? {
                        id: crypto.randomUUID(),
                        ...new APIModels.Party(),
                        submissionID: submission.id,
                    }
                }
                parties={completedParties}
                close={handlePartyClose}
            />
            <MaterialTable
                columns={[
                    {
                        title: "Party Type",
                        field: "partyType",
                    },
                    {
                        title: "Party Name",
                        field: "firstName",
                        render: (rowData) => (
                            <span>
                                {rowData.name
                                    ? rowData.name
                                    : rowData.firstName +
                                          " " +
                                          rowData.middleName ??
                                      "" + " " + rowData.lastName}
                            </span>
                        ),
                    },
                    {
                        title: "Attorney",
                        field: "attorney",
                        render: (rowData) => {
                            if (!rowData.attorney) {
                                return <span>Not Specified</span>;
                            } else
                                return (
                                    <span>
                                        {(
                                            rowData.attorney as APIModels.Attorney
                                        ).firstName +
                                            " " +
                                            (
                                                rowData.attorney as APIModels.Attorney
                                            ).lastName}
                                    </span>
                                );
                        },
                    },
                ]}
                options={{
                    search: false,
                }}
                data={parties}
                title={"Case Participants"}
            />
        </>
    );
}
